<template>
  <v-card v-if="conversion" id="conversion-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text class="text-right">
      <v-text-field
      class="py-6"
      v-model="conversion.name"
      :rules="[rules.required]"
      :label="$t('name')"
      color="black"
      :counter="maxNameLength"
      :maxlength="maxNameLength"
      ref="conversionName"/>
      <v-select
      v-model="conversion.impact"
      :items="ConversionImpact.enums"
      item-text="name"
      item-value="value"
      :label="$t('impact')"
      :hint="$t('conversionImpactHint')"
      persistent-hint
      color="black"
      class="text-left pb-6"/>
      <v-btn id="conversion-submit" color="primary" @click="submitClicked" :disabled="!canSubmit">
        {{ buttonText }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import fieldRules from '@/utils/rules.js'
import { StringConstants } from '@/utils/constants'
import { ConversionImpact } from '@/utils/Enumerations.js'

export default {
  name: 'ConversionForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propConversion: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created () {
    if (this.propConversion) {
      this.conversion = cloneDeep(this.propConversion)
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.conversionName.focus()
      document.addEventListener('keyup', this.onKeyup)
    }, 0)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyup)
  },

  computed: {
    editing () {
      return this.conversion?.conversionId
    },

    title () {
      return this.editing ? this.$t('editConversion') : this.$t('createNewConversion')
    },

    buttonText () {
      return this.editing ? this.$t('saveChanges') : this.$t('create')
    },

    canSubmit () {
      return this.conversion.name.length > 0 && this.conversion.name.length <= this.maxNameLength
    }
  },

  data: () => ({
    conversion: {
      name: '',
      impact: ConversionImpact.None.value
    },
    maxNameLength: StringConstants.MediumStringLength,
    rules: fieldRules.rules,
    ConversionImpact
  }),

  methods: {
    ...mapActions('tract', ['createConversion', 'updateConversion']),

    async submitClicked () {
      if (this.canSubmit) {
        this.editing ? await this.updateConversion(this.conversion) : await this.createConversion(this.conversion)
        this.$emit('conversion-mutated')
      } else {
        this.setSnackError(this.$t('nameIsRequired'))
      }
    },

    onKeyup (e) {
      if (e.key.toLowerCase() === 'enter') {
        this.submitClicked()
      }
    }
  }
}
</script>
